"use client"

import { useState } from "react"
import { usePathname, useRouter, useSearchParams } from "next/navigation"
import { Language } from "@/shared/types/type/language"
import { ModalProps } from "@/shared/types/interface/modal"
import useUIStore from "@/shared/stores/ui/store"
import { TextButton, Typography } from "@/shared/ui/atoms"
import { CustomButton } from "@/shared/ui/molecules"
import Modal from "."

const LanguageModal = ({ open, onClose }: ModalProps) => {
  const { language, setLanguage } = useUIStore()
  const [selectedLanguage, setSelectedLanguage] = useState<Language | null>(null)
  const router = useRouter()
  const pathname = usePathname()
  const searchParams = useSearchParams()

  const languageList = [
    {
      code: "ko",
      name: "한국어 Korean",
    },
    {
      code: "en",
      name: "영어 English",
    },
    {
      code: "cn",
      name: "중국어 中文(简体)",
    },
    {
      code: "jp",
      name: "일본어 日本語",
    },
  ]

  const handleLanguageChange = (newLocale: Language) => {
    const currentLocale = pathname?.split("/")[1]
    const pathWithoutLocale = pathname?.replace(`/${currentLocale}`, "") || "/"
    const newPath = `/${newLocale}${pathWithoutLocale}`
    const queryString = searchParams?.toString()
    const newUrl = queryString ? `${newPath}?${queryString}` : newPath

    setLanguage(newLocale)
    router.replace(newUrl)
    onClose()
  }

  return (
    <Modal open={open} title="언어" onClose={onClose}>
      {languageList.map((item) => (
        <div key={item.code} className={`w-full px-4`}>
          <TextButton
            text={item.name}
            onClick={() => setSelectedLanguage(item.code as Language)}
            className={`py-3 w-full text-center ${item.code === (selectedLanguage ?? language) ? "bg-[#F4F4F5]" : "bg-transparent"} rounded-lg`}
          />
        </div>
      ))}
      <CustomButton className="mt-6 w-full px-4" onClick={() => handleLanguageChange(selectedLanguage as Language)}>
        <Typography size={16} lineHeight={22} className="my-3 py-4 bg-primary-600 text-white text-center rounded-lg">
          선택완료
        </Typography>
      </CustomButton>
    </Modal>
  )
}

export default LanguageModal
